import { DZ_COLOR_YELLOW_400 } from '@blk/daisy/core/styles';
import { AbstractRenderer, Alignment, BusinessComponent, BusinessComponentOptions, ColumnPanel, RowPanel, StaticParagraphComponent } from '@blk/simba';
import { HeadingComponent, HeadingLevel } from '@ddt-web/pdf-components';

import { investmentProcessSteps } from './investment-process-steps-dcr';

export class InvestmentProcessComponent extends BusinessComponent {
	constructor(
		name: string,
		public modelsType: string,
		public asOfDate: string,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible }));
	}

	public buildComponent(): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];

		panels.push(
			new RowPanel('ME Investment Process Heading', [new HeadingComponent('INVESTMENT_PROCESS_HEADER', 'INVESTMENT PROCESS', HeadingLevel.H1)],
				{ marginBottom: 6 },
				Alignment.Horizontal.Left,
				Alignment.Vertical.Top),
			new RowPanel('Investment Process Description', [new StaticParagraphComponent('INVESTMENT_PROCESS_SUB_TEXT', 'Our approach to portfolio construction', {}, {}, ['text-16'])],
				{ marginBottom: 52 },
				Alignment.Horizontal.Left
			),

			...this.buildInvestmentProcessSteps()
		);

		return panels;
	}

	private buildInvestmentProcessSteps(): RowPanel[] {
		const stepsPanels: ColumnPanel[] = [];

		investmentProcessSteps.forEach((step, index) => {

			stepsPanels.push(new ColumnPanel(`Investment panel step ${index + 1}`, [
				new ColumnPanel('',
					[new StaticParagraphComponent('', `0${index + 1}.`, {}, {}, ['text-extra-bold', 'text-30'])],
					{ borderBottom: 5, borderBottomColor: DZ_COLOR_YELLOW_400, width: 130, marginBottom: 12, paddingBottom: 12 },
					Alignment.Horizontal.Left),
				new StaticParagraphComponent(`${step.header.dcrKey}${this.modelsType ? '_' + this.modelsType.toLocaleUpperCase() : ''}`,
					step.header.dcrValue, {}, { marginBottom: 8 }, ['text-extra-bold', 'text-16']),
				new StaticParagraphComponent(`${step.description.dcrKey}${this.modelsType ? '_' + this.modelsType.toLocaleUpperCase() : ''}`,
					step.description.dcrValue, {}, {}, ['text-9'])
			], { proportion: 22 }, Alignment.Horizontal.Left)
			);
			//space between the steps
			if ((index + 1) % 4) {
				stepsPanels.push(new ColumnPanel('empty box', [], { proportion: 4, useFullWidth: true }));
			}

		});

		//dummy column to cover the remaining proportion
		if (investmentProcessSteps.length < 4) {
			stepsPanels.push(new ColumnPanel('dummy column', [], { proportion: 26 * (4 - investmentProcessSteps.length) - 4 }));
		}
		// keeping the return type as [], if any future scope to add more steps 
		return [new RowPanel('steps row', stepsPanels, { useFullWidth: true })];
	}

}

